module.exports = __webpack_public_path__ + "static/media/first-page-image.71aad553.jpg";